export const KeycloakManagerConfig = Object.freeze({
  realm: 'co-customer',
  clientId: 'co-pse-cashout',
});
